export const SET_IS_SHOW_GOOD_LIST = 'SET_IS_SHOW_GOOD_LIST';
export const SET_DIALOG_SYNC_CROWD = 'SET_DIALOG_SYNC_CROWD';
export const SET_QQ_CROWD_LIST = 'SET_QQ_CROWD_LIST';
export const SET_CHECKED_PRODUCT_ID_LIST = 'SET_CHECKED_PRODUCT_ID_LIST';
export const SET_QQ_CROWD_STATE_LIST = 'SET_QQ_CROWD_STATE_LIST';
export const SET_QQ_CROWD_INVITE_CODE = 'SET_QQ_CROWD_INVITE_CODE';

export const SET_MEDIA_LIST = 'SET_MEDIA_LIST';
export const SET_ACTIVE_MEDIA = 'SET_ACTIVE_MEDIA';
export const SET_MEDIA_INFO = 'SET_MEDIA_INFO';
